import api from './api'

export const brandService = {
  /**
   * Fetches every brand
   * @param {boolean} activeOnly - When true, returns active brands only
   * @returns {Promise<Array>} Lista de marcas
   */
  async getAllBrands() {
    const response = await api.get('/brands')
    return response.data
  },

  /**
   * Fetches every brand in the system
   * @param {boolean} activeOnly - When true, returns active brands only
   * @returns {Promise<Array>} Lista de marcas
   */
  async getBrands(activeOnly = false) {
    try {
      const response = await api.get('/settings/brands', {
        params: { active: activeOnly }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching brands:', error)
      throw error
    }
  }
}